// extracted by mini-css-extract-plugin
module.exports = {"item":"HorizontalCard_item__Q4QiR","title":"HorizontalCard_title__kckcZ","date":"HorizontalCard_date__8_OL8","thumbnail":"HorizontalCard_thumbnail__KvF8m"};